module.exports = __webpack_public_path__ + "img/ico_5.990d08ed.png";